require('jquery-ui/ui/widget');
require('jquery-ui/ui/keycode');
require('jquery-ui/ui/unique-id');
require('jquery-ui/ui/widgets/accordion');
require('jquery-ui/themes/base/core.css');
require('jquery-ui/themes/base/accordion.css');